window.addEventListener('DOMContentLoaded', () => {
    const cardContentSwiper = document.querySelectorAll('.card-content-swiper');

    if (cardContentSwiper.length) {
        [].forEach.call(cardContentSwiper, (grid) => {
            const gridContainerInner = grid.querySelector('.card-content-swiper__inner');

            const handleSwiperClasses = (value) => {
                const gridContainer = grid.querySelector('.card-content-swiper__items');
                const gridContainerItems = grid.querySelector(
                    '.card-content-swiper__items',
                ).children;

                if (value === 'add') {
                    gridContainer.classList.add('swiper-wrapper');
                    [].forEach.call(gridContainerItems, (item) => {
                        item.classList.add('swiper-slide');
                    });
                }

                if (value === 'remove') {
                    gridContainer.classList.remove('swiper-wrapper');
                    [].forEach.call(gridContainerItems, (item) => {
                        item.classList.remove('swiper-slide');
                    });
                }
            };

            const checkBreakpoint = () => {
                const breakpointMediumDown = window.matchMedia('(max-width: 1025px)');
                let swiperActive;

                if (breakpointMediumDown.matches) {
                    swiperActive = true;
                    return swiperActive;
                } else {
                    swiperActive = false;
                    return swiperActive;
                }
            };

            const activateSwiper = (swiperInstance) => {
                let swiper = swiperInstance.swiper;
                if (checkBreakpoint()) {
                    if (swiper == null) {
                        handleSwiperClasses('add');
                        new Swiper(swiperInstance, {
                            slidesPerView: 'auto',
                            watchOverflow: true,
                            pagination: {
                                el: '.swiper-pagination',
                                type: 'bullets',
                                clickable: true,
                            },
                            navigation: {
                                nextEl: '.swiper-button-next',
                                prevEl: '.swiper-button-prev',
                            },
                        });
                    }
                } else {
                    if (swiper != null) {
                        handleSwiperClasses('remove');
                        swiper.destroy();
                    }
                }
            };

            activateSwiper(gridContainerInner);

            window.addEventListener('resize', () => {
                activateSwiper(gridContainerInner);
            });
        });
    }
});
